export default __webpack_public_path__ + "static/media/hordeIcon.4d94dba6.png";